// components
import { Head } from "components/molecules/Head/Head";

// constants
import { PageTitles, LandingPage as Constants } from "constants/global";

// styles
import styles from "containers/LandingPage/landingPage.module.css";

// utils
import getIcon from "utils/getIcon";

const LandingPage = () => {
	return (
		<div className={styles?.root}>
			<div className={styles?.bg_curve}>{getIcon({ icon: "landingPageBackground" })}</div>
			<div className={styles?.bg_frame}>{getIcon({ icon: "happyAnnouncement" })}</div>
			<Head>{PageTitles.HOME}</Head>
			<div className={styles?.content_wrapper}>
				<h1 className={styles?.header}>{Constants?.TITLE}</h1>
				<p className={styles?.description}>
					{Constants.DESC_PREFIX}
					<span className={styles?.desc_hero}>{Constants?.DESC}</span>
				</p>
			</div>
		</div>
	);
};

export default LandingPage;
